'use clinet'

import SectionTitle from "@/components/etc/section_title";
import { BoardViewTypes, EventMatchListType } from "@/type/list";
import api from "@/util/api";
import moment from "moment";
import { useRouter } from "next/navigation";
import defaultThumnail from "@/public/image/etc/default_thumnail.png"
import { useEffect, useState } from "react";
import getThumbnail from "@/util/getThumbnail";


import thumbnail_soccer from "@/public/image/event/soccer.png"
import thumbnail_basketball from "@/public/image/event/basketball.jpg"
import thumbnail_baseball from "@/public/image/event/baseball.jpg"
import ListV2 from "@/components/board/list_v2"
import { useTranslations } from "next-intl";

export default function SportsAnalysisRanding() {
    const [listSportsAnalysis, setListSportsAnalysis] = useState<any[]>([])
    const [addThumnail, setAddThumnail] = useState<any[]>([])

    const p = useTranslations("PageTitle")

    const router = useRouter()
    
    const fetchData = async () => {
        api(`/api/event/match/?page_count=5`)
            .then(res => res.json())
            .then(({ data }) => {
                setListSportsAnalysis(data?.posts ?? []); 
            })
    };

    const movePage = (id:number) => {
        router.push(`/eventmatch/?id=${id}`)
        window.scrollTo({ top: 0 });
    }

    useEffect(()=> {
        fetchData()
    }, [])

    useEffect(() => {
        if (!listSportsAnalysis) return;
        const addThumnail = listSportsAnalysis.map((el) => {
            let thumbnail_img: string = "";
            switch (el.sports_type) {
                case 1: thumbnail_img = thumbnail_soccer.src; break;
                case 2: thumbnail_img = thumbnail_basketball.src; break;
                case 3: thumbnail_img = thumbnail_baseball.src; break;
            }
            if(el.thumbnail == null){
                switch (el.sports_type) {
                    case 1: thumbnail_img = thumbnail_soccer.src; break;
                    case 2: thumbnail_img = thumbnail_basketball.src; break;
                    case 3: thumbnail_img = thumbnail_baseball.src; break;
                }
            }else{
                thumbnail_img = el.thumbnail;
            }
            return { ...el, thumbnail: thumbnail_img }
        })
        setAddThumnail(addThumnail)
    }, [listSportsAnalysis])

    return (
        <div className="p-r-5 p-l-5">
            <SectionTitle shortCut={`/eventmatch/`} type="event-match" >{p.rich("이벤트 b:매치", { b: (c)=> <b>{c}</b> })} </SectionTitle>
            
            <ListV2 list={addThumnail} 
                    setContent={movePage} 
                    type={"thumbnail"} />
        </div>
    )
}